import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { OFFER_ANCHOR } from '../utils/checkout';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'amber' | 'ocean' | 'white';
  href?: string;
  attention?: boolean;
}
export function CTAButton({
  children,
  className = '',
  variant = 'amber',
  href = OFFER_ANCHOR,
  attention = true
}: CTAButtonProps) {
  const colors = {
    amber: 'bg-brand-amber text-brand-night hover:bg-[#c9932f] focus-visible:ring-brand-amber',
    ocean: 'bg-brand-ocean text-white hover:bg-brand-deep focus-visible:ring-brand-ocean',
    white: 'bg-white text-brand-ocean hover:bg-brand-main focus-visible:ring-white'
  }[variant];
  return <a href={href} className={`${attention ? 'cta-attention' : ''} inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm font-extrabold tracking-wide shadow-md transition-[background-color,box-shadow] duration-200 ease-out hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:text-base ${colors} ${className}`} data-id="element-50" data-mp="2yr49lakbb6uo">
      {children}
      <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-51" data-mp="1db9ottcsb7z9" />
    </a>;
}